import { render } from "./OptionalComponents.vue?vue&type=template&id=4a80aecc&scoped=true"
import script from "./OptionalComponents.vue?vue&type=script&lang=js"
export * from "./OptionalComponents.vue?vue&type=script&lang=js"

import "./OptionalComponents.vue?vue&type=style&index=0&id=4a80aecc&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a80aecc"]])

export default __exports__